import { fetcher } from "helpers/fetcher";

import { TGetBUStaffNotesReq, TGetBUStaffNotesRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getBUStaffNotes = async (params?: TGetBUStaffNotesReq) => {
  return await fetcher<TGetBUStaffNotesRes, TGetBUStaffNotesReq>(
    ENDPOINT.BU.GET_BU_STAFF_NOTES,
    {
      params: params?.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.BU.GET_BU_STAFF_NOTES.version,
        [API_HEADER.BU_ID]: params?.idBu,
      },
    }
  );
};

export const queryGetBUStaffNotes = async (params?: TGetBUStaffNotesReq) => {
  return (await getBUStaffNotes(params)).data;
};

queryGetBUStaffNotes._key = (params?: TGetBUStaffNotesReq) => [
  ENDPOINT.BU.GET_BU_STAFF_NOTES.url,
  params,
];
